import Assets from '../../../../requests/apa/Asset';

/**
 * Mock data para MatchDetailLineups - Large/Plantilla (node 106:11182)
 * Posiciones x/y como % del campo (0,0=esquina top-left, 100,100=esquina bottom-right)
 * El centro del card del jugador se posiciona en (x%, y%)
 *
 * Conversión px→rem: (px / 1.5) / 10
 * Campo Figma: 1200×592px → 80rem × 39.467rem
 *
 * Eventos posibles por jugador:
 *   'yellow'            → tarjeta amarilla
 *   'red'               → roja directa
 *   'red_second_yellow' → roja (2da amarilla)
 *   'sub_in'            → entra al campo
 *   'sub_out'           → sale del campo
 *   'goal'              → gol
 *   'own_goal'          → gol en propia
 */

/**
 * Iconos Cancha — SVG data URIs (siempre accesibles en navegador).
 *
 * Corresponden a los componentes Figma Large/Jugadores (node 106:11182):
 *   Cancha Page-1 (16:2090)   → tarjeta amarilla
 *   Cancha Page-1 (16:2086)   → tarjeta roja
 *   Cancha Group31433 (47:3630) → flecha sub_in (verde ↑)
 *   Cancha Vector (16:2081)   → flecha sub_out (roja ↓)
 *   Cancha Clip path group    → doble flecha sub_in+sub_out (BR)
 *   Balón / gol               → pelota con estrella (blanca)
 */
export var CANCHA_ICONS = {
  // Cancha Page-1 (16:2090) — tarjeta amarilla, portrait 7.25:11.25
  yellowCard: Assets.get('eventodeportivo_icono_amarilla_2'),
  // Cancha Page-1 (16:2086) — tarjeta roja, mismo shape
  redCard:    Assets.get('eventodeportivo_icono_roja_2'),
  // Cancha Group31433 (47:3630) — flecha verde ↑ sub_in, aspect 8:12
  subIn:      Assets.get('eventodeportivo_icono_entra'),
  // Cancha Vector (16:2081) — flecha roja ↓ sub_out, aspect 10:12
  subOut:     Assets.get('eventodeportivo_icono_sale'),
  // Balón / gol — círculo naranja con estrella blanca (distinto de la flecha verde sub_in)
  goal:       Assets.get('eventodeportivo_icono_gol_2'),
 // Cancha Page-1 (16:2086) — tarjeta roja combinada con amarillo, expulsion
  yellowRedCard: Assets.get('eventodeportivo_icono_amarillaroja_2')
};

export const LINEUPS_MOCK = {
  homeTeam: {
    name: 'Argentina',
    shortName: 'ARG',
    flagUrl: 'https://upload.wikimedia.org/wikipedia/commons/1/1a/24701-argentina-flag.png',
    teamColor: '#89c7e2',
    formation: '4-3-3',
    coach: {
      name: 'Lionel Scaloni',
      photoUrl: 'https://media.api-sports.io/football/players/154.png'
    },
    starters: [
      {
        id: 1,
        number: 1,
        name: 'E. Martínez',
        photoUrl: 'https://media.api-sports.io/football/players/370.png',
        x: 7,
        y: 50,
        events: []
      },
      {
        id: 2,
        number: 13,
        name: 'C. Romero',
        photoUrl: 'https://media.api-sports.io/football/players/1483.png',
        x: 19,
        y: 22,
        events: []
      },
      {
        id: 3,
        number: 2,
        name: 'N. Otamendi',
        photoUrl: 'https://media.api-sports.io/football/players/1484.png',
        x: 19,
        y: 42,
        events: []
      },
      {
        id: 4,
        number: 8,
        name: 'N. Tagliafico',
        photoUrl: 'https://media.api-sports.io/football/players/1485.png',
        x: 19,
        y: 62,
        events: []
      },
      {
        id: 5,
        number: 25,
        name: 'G. Montiel',
        photoUrl: 'https://media.api-sports.io/football/players/1486.png',
        x: 19,
        y: 82,
        events: []
      },
      {
        id: 6,
        number: 7,
        name: 'R. De Paul',
        photoUrl: 'https://media.api-sports.io/football/players/1487.png',
        x: 31,
        y: 22,
        events: ['yellow', 'sub_in'],
        iconUrls: { yellow: CANCHA_ICONS.yellowCard, sub_in: CANCHA_ICONS.subIn }
      },
      {
        id: 7,
        number: 20,
        name: 'Mac Allister',
        photoUrl: 'https://media.api-sports.io/football/players/1488.png',
        x: 31,
        y: 50,
        events: ['sub_in', 'sub_out'],
        iconUrls: { sub_in: CANCHA_ICONS.subIn, sub_out: CANCHA_ICONS.subOut }
      },
      {
        id: 8,
        number: 24,
        name: 'E. Fernández',
        photoUrl: 'https://media.api-sports.io/football/players/1489.png',
        x: 31,
        y: 78,
        events: ['red_second_yellow', 'yellow'],
        iconUrls: { red_second_yellow: CANCHA_ICONS.redCard, yellow: CANCHA_ICONS.yellowCard }
      },
      {
        id: 9,
        number: 11,
        name: 'Á. Di María',
        photoUrl: 'https://media.api-sports.io/football/players/1490.png',
        x: 43,
        y: 16,
        events: []
      },
      {
        id: 10,
        number: 10,
        name: 'L. Messi',
        photoUrl: 'https://media.api-sports.io/football/players/154.png',
        x: 43,
        y: 39,
        events: ['goal'],
        iconUrls: { goal: CANCHA_ICONS.goal }
      },
      {
        id: 11,
        number: 9,
        name: 'J. Álvarez',
        photoUrl: 'https://media.api-sports.io/football/players/1491.png',
        x: 43,
        y: 62,
        events: []
      }
    ],
    bench: [
      { number: 12, name: 'G. Rulli',    subEvent: { minute: 85, name: 'Gerónimo Rulli', iconUrl: CANCHA_ICONS.subIn, minuteColor: '#56BC37' } },
      { number: 3,  name: 'L. Martínez', iconUrls: { yellow: CANCHA_ICONS.yellowCard } },
      { number: 4,  name: 'E. Pezzella', iconUrls: { goal: CANCHA_ICONS.goal } },
      { number: 5,  name: 'L. Paredes',  iconUrls: { yellow: CANCHA_ICONS.yellowCard } },
      { number: 6,  name: 'M. Acuña' },
      { number: 15, name: 'G. Lo Celso', iconUrls: { sub_in: CANCHA_ICONS.goal } },
      { number: 16, name: 'T. Palacios' },
      { number: 7,  name: 'R. Almada' },
      { number: 17, name: 'N. González' },
      { number: 20, name: 'L. Ballerini' },
      { number: 22, name: 'F. Medina' }
    ],
    subBench: [
      { number: 23, name: 'G. Mossi' },
      { number: 24, name: 'E. Cambiasso' },
      { number: 25, name: 'J. Correa' },
      { number: 26, name: 'L. Ocampos' }
    ]
  },

  awayTeam: {
    name: 'Austria',
    shortName: 'AUT',
    flagUrl: 'https://upload.wikimedia.org/wikipedia/commons/4/41/Flag_of_Austria.svg',
    teamColor: '#fe0100',
    formation: '4-3-3',
    coach: {
      name: 'Ralf Rangnick',
      photoUrl: 'https://media.api-sports.io/football/players/2001.png'
    },
    starters: [
      {
        id: 22,
        number: 1,
        name: 'P. Pentz',
        photoUrl: 'https://media.api-sports.io/football/players/2000.png',
        x: 93,
        y: 50,
        events: []
      },
      {
        id: 21,
        number: 5,
        name: 'S. Posch',
        photoUrl: 'https://media.api-sports.io/football/players/2001.png',
        x: 81,
        y: 22,
        events: ['red'],
        iconUrls: { red: CANCHA_ICONS.redCard }
      },
      {
        id: 20,
        number: 3,
        name: 'P. Lienhart',
        photoUrl: 'https://media.api-sports.io/football/players/2002.png',
        x: 81,
        y: 42,
        events: []
      },
      {
        id: 19,
        number: 4,
        name: 'K. Danso',
        photoUrl: 'https://media.api-sports.io/football/players/2003.png',
        x: 81,
        y: 62,
        events: []
      },
      {
        id: 18,
        number: 17,
        name: 'M. Wöber',
        photoUrl: 'https://media.api-sports.io/football/players/2004.png',
        x: 81,
        y: 82,
        events: []
      },
      {
        id: 17,
        number: 8,
        name: 'F. Grillitsch',
        photoUrl: 'https://media.api-sports.io/football/players/2005.png',
        x: 69,
        y: 22,
        events: []
      },
      {
        id: 16,
        number: 10,
        name: 'C. Laimer',
        photoUrl: 'https://media.api-sports.io/football/players/2006.png',
        x: 69,
        y: 50,
        events: ['yellow'],
        iconUrls: { yellow: CANCHA_ICONS.yellowCard }
      },
      {
        id: 15,
        number: 7,
        name: 'C. Baumgartner',
        photoUrl: 'https://media.api-sports.io/football/players/2007.png',
        x: 69,
        y: 78,
        events: ['yellow', 'red'],
        iconUrls: { yellow: CANCHA_ICONS.yellowCard, red: CANCHA_ICONS.redCard }
      },
      {
        id: 14,
        number: 11,
        name: 'M. Sabitzer',
        photoUrl: 'https://media.api-sports.io/football/players/2008.png',
        x: 57,
        y: 16,
        events: []
      },
      {
        id: 13,
        number: 9,
        name: 'M. Gregoritsch',
        photoUrl: 'https://media.api-sports.io/football/players/2009.png',
        x: 57,
        y: 39,
        events: ['yellow', 'sub_in'],
        iconUrls: { yellow: CANCHA_ICONS.yellowCard, sub_in: CANCHA_ICONS.subIn }
      },
      {
        id: 12,
        number: 14,
        name: 'M. Weimann',
        photoUrl: 'https://media.api-sports.io/football/players/2010.png',
        x: 57,
        y: 62,
        events: ['sub_out'],
        iconUrls: { sub_out: CANCHA_ICONS.subOut }
      }
    ],
    bench: [
      { number: 12, name: 'H. Lindner' },
      { number: 2,  name: 'F. Trimmel',  iconUrls: { sub_in: CANCHA_ICONS.subIn } },
      { number: 6,  name: 'J. Wöber',   iconUrls: { yellow: CANCHA_ICONS.yellowCard } },
      { number: 16, name: 'P. Grull' },
      { number: 13, name: 'F. Kainz',   iconUrls: { red: CANCHA_ICONS.redCard } },
      { number: 18, name: 'N. Seiwald', iconUrls: { yellow: CANCHA_ICONS.yellowCard } },
      { number: 19, name: 'K. Onisiwo', iconUrls: { sub_in: CANCHA_ICONS.goal },           subEvent: { minute: 72, name: 'Karim Onisiwo', iconUrl: CANCHA_ICONS.subIn, minuteColor: '#56BC37' } },
      { number: 22, name: 'A. Schlager' },
      { number: 15, name: 'D. Ljubicic' },
      { number: 11, name: 'M. Entrup' },
      { number: 20, name: 'P. Wimmer' }
    ],
    subBench: [
      { number: 23, name: 'C. Oswald' },
      { number: 24, name: 'M. Sollbauer' },
      { number: 25, name: 'R. Baumgartlinger' },
      { number: 26, name: 'T. Goiginger' }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/mock/matchDetailLineupsData.js